import { defaultClient as httpClient } from 'tradera-utils/http';
import ENDPOINTS from 'tradera-constants/endpoints';

const sendSessionStart = () => {
    httpClient.post(ENDPOINTS.SELLING_SCRIBE_SESSION_START);
};

const sendSessionDuration = (duration, madeByTemplate) => {
    httpClient.post(ENDPOINTS.SELLING_SCRIBE_SESSION_DURATION, {
        durationMilliSeconds: duration,
        madeByTemplate: madeByTemplate
    });
};

const sendDuration = (measuredName, durationMilliSeconds) => {
    httpClient.post(ENDPOINTS.SELLING_SCRIBE_DURATION, {
        measuredName: measuredName,
        durationMilliSeconds: durationMilliSeconds
    });
};

const sendIncrement = name => {
    httpClient.post(ENDPOINTS.SELLING_SCRIBE_INCREMENT, {
        name: name
    });
};

const sendValidationErrors = errors => {
    httpClient.post(ENDPOINTS.SELLING_SCRIBE_VALIDATION_ERRORS, {
        errors: errors
    });
};

export default {
    sendSessionStart,
    sendSessionDuration,
    sendDuration,
    sendIncrement,
    sendValidationErrors
};
